import * as yup from 'yup';

export const taxCertificationSchema = yup.object().shape({
  totalAssessedValue: yup
    .string()
    .matches(
      /^(N\/A|\$\d{1,3}\.[0-9]{2}$|^\$(\d{1,3},)+\d{3}\.[0-9]{2})$/,
      "Value must be formatted as a currency string ($#,###.##) or 'N/A'"
    )
    .nullable(),
  assessedMarketValue: yup
    .string()
    .matches(
      /^(N\/A|\$\d{1,3}\.[0-9]{2}$|^\$(\d{1,3},)+\d{3}\.[0-9]{2})$/,
      "Value must be formatted as a currency string ($#,###.##) or 'N/A'"
    )
    .nullable(),
});
